var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfileLanguage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1416_9846)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#070707"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.9271,
    y: 16.9346,
    width: 15.3181,
    height: 12.7029,
    rx: 2,
    fill: "#070707",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9725 21.3762H25.6992M29.4693 21.3762H25.6992M25.6992 19.0955V21.3762",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5543 22.5298C24.0359 23.7285 25.8931 26.08 29.4691 25.8956M21.7031 25.8956C22.9824 26.0494 26.0105 25.5915 27.8888 22.5298",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.48901,
    y: 10.1426,
    width: 15.8492,
    height: 13.1433,
    rx: 2,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8219 20.6456L14.5811 18.0842M19.0053 20.6456L18.069 18.0842M18.069 18.0842L17.0433 14.4268C16.8383 13.6961 15.8021 13.6971 15.5986 14.4282L14.5811 18.0842M18.069 18.0842H14.5811",
    stroke: "#070707",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1416_9846"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileLanguage);
export default __webpack_public_path__ + "static/media/profile-language.26a965be7400ee9838e367a39844542d.svg";
export { ForwardRef as ReactComponent };